import React from "react"
import PropTypes from "prop-types"

const PageLoadingShell = ({ children }) => (
  <div className="container-fluid relative mx-auto min-h-[calc(100vh-252px)] flex justify-center items-start bg-cream">
    {children ?? (
      <div
        className="container p-[32px] max-md:p-[16px] max-w-[1496px] mb-[32px] mx-auto bg-white rounded-lg shadow-2xl w-full"
        aria-busy="true"
        aria-live="polite"
      >
        <div className="h-8 bg-lightGray rounded w-1/3 mb-6 animate-pulse" />
        <div className="h-64 bg-lightGray rounded animate-pulse" />
      </div>
    )}
  </div>
)

PageLoadingShell.propTypes = {
  children: PropTypes.node,
}

export default PageLoadingShell
